/**
 * Populates the Race/Ethnicity dropdown menu for the personal details dataset
 * Adds validation for dataset templates
 */
 export const Forms = (function () {

    var init = function () {
        ds_personal_details.init();
        ds_home.init();
        setPageState();
    }

    // Personal Details dataset template
    var ds_personal_details = {
        init: function () {
            this.addRaceAndEthnicity();
            toggleLandlordOptions();
        },

        // Populates the race and ethnicity dropdown
        addRaceAndEthnicity: function () {
        // Check if the race/ethnicity field is on the page before making request to MRD
        if ($('#field_personal_ethnicityID').length) {
            var promise = MRD.listings.getRaceEthnicity()
            promise.then(function (response) {
                // Returns response which is all of the ethnicities
                response.forEach(ethnicity => {
                    // Creates an optgroup in the dropdown which are the main categories
                    if (ethnicity.parent_id == "0") {
                        $('#field_personal_ethnicityID').append($("<optgroup></optgroup>")
                            .attr({
                                "label": ethnicity.ethnicity,
                                'id': ethnicity.id
                            }))

                        // Adds the sub categories as options under the matching main category
                    } else if (ethnicity.parent_id == "1") {
                        $('<option>').text(ethnicity.ethnicity).appendTo('#1')
                    } else if (ethnicity.parent_id == "2") {
                        $('<option>').text(ethnicity.ethnicity).appendTo('#2')
                    } else if (ethnicity.parent_id == "3") {
                        $('<option>').text(ethnicity.ethnicity).appendTo('#3')
                    } else if (ethnicity.parent_id == "4") {
                        $('<option>').text(ethnicity.ethnicity).appendTo('#4')
                    } else if (ethnicity.parent_id == "5") {
                        $('<option>').text(ethnicity.ethnicity).appendTo('#5')
                    } else if (ethnicity.parent_id == "6") {
                        $('<option>').text(ethnicity.ethnicity).appendTo('#6')
                    } else if (ethnicity.parent_id == "7") {
                        $('<option>').text(ethnicity.ethnicity).appendTo('#7')
                    } else if (ethnicity.parent_id == "8") {
                        $('<option>').text(ethnicity.ethnicity).appendTo('#8')
                    }
                })
            })
        }
    },
}

    // Home dataset template
    var ds_home = {
        init: function () {
            toggleLandlordOptions();
            this.toggleMaidenName();
        },

        // Toggles the Maiden Name option from being displayed if Title selected is "Mr"
        toggleMaidenName: function () {
            $('#field_personal_titleID').change(function () {
                if ($(this).val() == "Mr") {
                    $('#field_personal_manameID').parent().hide();
                }
                else {
                    $('#field_personal_manameID').parent().show();
                }
            })
        }
    }
    
    // Toggles the landlord options from being displayed if tenancy type is "Owner Occupier"
    function toggleLandlordOptions() {
        $('#field_home_tenancyID').change(function () {
            if ($(this).val() == "Owner Occupier") {
                $('#field_home_owner_streetID').parent().hide();
                $('#field_home_owner_townID').parent().hide();
                $('#field_home_owner_countyID').parent().hide();
                $('#field_home_owner_postcodeID').parent().hide();
                $('#field_home_owner_countryID').parent().hide();
            }
            else {
                $('#field_home_owner_streetID').parent().show();
                $('#field_home_owner_townID').parent().show();
                $('#field_home_owner_countyID').parent().show();
                $('#field_home_owner_postcodeID').parent().show();
                $('#field_home_owner_countryID').parent().show();
            }
        })
    }

    // Required due to when the values of the options are loaded from the PDS
    // Checks if these options have already been filled out and does the processing required
    function setPageState() {
        $(window).on('pageshow', function () {
            setTimeout(function () {
                if ($('#field_personal_titleID option:selected').val() != "Mr") {
                    $('#field_personal_manameID').parent().show();
                } else {
                    $('#field_personal_manameID').parent().hide();
                }

                if ($('#field_home_tenancyID option:selected').val() != "Owner Occupier") {
                    $('#field_home_owner_streetID').parent().show();
                    $('#field_home_owner_townID').parent().show();
                    $('#field_home_owner_countyID').parent().show();
                    $('#field_home_owner_postcodeID').parent().show();
                    $('#field_home_owner_countryID').parent().show();
                } else {
                    $('#field_home_owner_streetID').parent().hide();
                    $('#field_home_owner_townID').parent().hide();
                    $('#field_home_owner_countyID').parent().hide();
                    $('#field_home_owner_postcodeID').parent().hide();
                    $('#field_home_owner_countryID').parent().hide();
                }
            }, 1000);

        })
    }
    return {
        init: init
    }
}());
